import { Component } from 'react';
import { mergeRight } from 'ramda';
import { MapNavigator } from '../../components';
import s from './HostStyles.module.scss';

const levelsWithMapNotes = [{ ordinalId: 'ordinal: 1', structureId: 'dynamicgso-terminal' }];
const structures = [
    {
        id: 'dynamicgso-terminal',
        defaultLevelId: 'dynamicgso-terminal-2',
        name: 'Terminal',
        venueId: 'dynamicgso',
        levelIds: ['dynamicgso-terminal-1', 'dynamicgso-terminal-2'],
        levels: [
            {
                details: 'Arrivals',
                id: 'dynamicgso-terminal-1',
                name: 'Level 1',
                structureId: 'dynamicgso-terminal',
                venueId: 'dynamicgso',
                boundsPolygon: [],
                bounds: {},
                ordinalId: 'ordinal: 1',
                ordinalNumber: 1,
            },
            {
                details: 'Departures',
                id: 'dynamicgso-terminal-2',
                name: 'Level 2',
                structureId: 'dynamicgso-terminal',
                venueId: 'dynamicgso',
                boundsPolygon: [],
                bounds: {},
                ordinalId: 'ordinal: 2',
                ordinalNumber: 2,
            },
        ],
    },
    {
        id: 'dynamicgso-otherterminal',
        defaultLevelId: 'dynamicgso-otherterminal-1',
        name: 'Other Terminal',
        venueId: 'dynamicgso',
        levelIds: ['dynamicgso-otherterminal-1', 'dynamicgso-otherterminal-2'],
        levels: [
            {
                details: 'Arrivals',
                id: 'dynamicgso-otherterminal-1',
                name: 'Level 1',
                structureId: 'dynamicgso-otherterminal',
                venueId: 'dynamicgso',
                boundsPolygon: [],
                bounds: {},
                ordinalId: 'ordinal: 1',
                ordinalNumber: 1,
            },
            {
                details: 'Departures',
                id: 'dynamicgso-otherterminal-2',
                name: 'Level 2',
                structureId: 'dynamicgso-otherterminal',
                venueId: 'dynamicgso',
                boundsPolygon: [],
                bounds: {},
                ordinalId: 'ordinal: 2',
                ordinalNumber: 2,
            },
        ],
    },
];

const initialState = {
    selectedLevel: undefined,
    selectedStructure: undefined,
};

const defaultLevel = structure => structure.levels[1];

export default class MapNavigatorHost extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
        this.selectLevel = this.selectLevel.bind(this);
        this.selectStructure = this.selectStructure.bind(this);
    }

    selectLevel(selectedLevel) {
        this.setState(state => mergeRight(state, { selectedLevel }));
    }

    selectStructure(selectedStructure) {
        this.setState(state =>
            mergeRight(state, {
                selectedStructure,
                selectedLevel: defaultLevel(selectedStructure),
            }),
        );
    }

    render() {
        const mapNavigator = (
            <MapNavigator
                structures={structures}
                selectedStructure={this.state.selectedStructure}
                selectedLevel={this.state.selectedLevel}
                selectLevel={this.selectLevel}
                selectStructure={this.selectStructure}
                levelsWithMapNotes={levelsWithMapNotes}
            />
        );

        return (
            <div className={s.editor} style={{ padding: '500px' }}>
                {mapNavigator}
                <br />
                <br />
                <button type="button" onClick={() => this.setState(initialState)}>
                    Reset
                </button>
            </div>
        );
    }
}
